// SPDX-License-Identifier: AGPL-3.0-or-later

import {PREMIUM_PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {PlutoniumUpsell} from '@app/features/ui/plutonium_upsell/PlutoniumUpsell';
import {UserSettingsModal} from '@app/features/user/components/modals/UserSettingsModal';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const PlutoniumUpsellBanner = observer(() => {
	return (
		<PlutoniumUpsell
			buttonText={<Trans>View Plans</Trans>}
			onButtonClick={() => {
				ModalCommands.pop();
				ModalCommands.push(modal(() => <UserSettingsModal initialTab="plutonium" />));
			}}
		>
			<Trans>Get {PREMIUM_PRODUCT_NAME} for yourself and unlock higher limits and exclusive features.</Trans>
		</PlutoniumUpsell>
	);
});
